import React from 'react';
import { connect } from 'react-redux';
import Valg from '../../Shared/Scripts/Models/Valg';
import VeilederStegComponent, { VeilederStegDefaultProps, VeilederStegBaseProps } from '../../Shared/Scripts/Components/VeilederStegComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import ForelopigUttalelseSkjemaSideDto from '../Models/ForelopigUttalelseSkjemaSideDto';
import { ForelopigUttalelseSkjemaSideAppState } from '../Store';
import {ja, nei} from '../Models/Values';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { setCollapsed } from '../../Shared/Scripts/Store/StegVisning/Actions';
import { StegVisning } from '../../Shared/Scripts/Store/StegVisning/Types';

type Steg2ComponentOwnProps = VeilederStegDefaultProps & VeilederStegBaseProps & {
    ledetekst: JSX.Element | null,
    onChange: any,
    value?: Valg<string>,
}

type Steg2DisplayProps = Steg2ComponentOwnProps & MapStateToProps & MapDispatchToProps;

function Steg2ComponentVisning(props: Steg2DisplayProps): JSX.Element {
    const { epiContext } = props;
    
    function utdanningRadioKlikkHandler(e: React.SyntheticEvent<HTMLInputElement>): void {
        let displayValue: string = '';

        if(e.currentTarget.value === ja) {
            if(epiContext.epiModel?.steg2ValgJa !== undefined && epiContext.epiModel?.steg2ValgJa !== null)
                displayValue = epiContext.epiModel?.steg2ValgJa.value;
        }

        if(e.currentTarget.value === nei) {
            if(epiContext.epiModel?.steg2ValgNei !== undefined && epiContext.epiModel?.steg2ValgNei !== null)
                displayValue = epiContext.epiModel?.steg2ValgNei.value;
        }

        let valg: Valg<string> = { id: 'steg2', displayValue: displayValue, value: e.currentTarget.value }
        props.onChange(valg);
        props.stegVisningSetCollapsed({id: props.sporsmalId,isCollapsed:false});
    }

    return (
        <VeilederStegComponent
            tittel={props.tittel}
            forklaring={props.forklaring}
            canCollapse={!props.neverCollapse}
            displayElement={<div className="c-veileder__valgt-item">
                <span className="c-veileder__tekst c-veileder__tekst--valg">{props.value?.displayValue}</span>
            </div>}
            inputArea={
                <div className="c-veileder__inputomrade">
                    <div className="c-veileder__inputomrade c-veileder__paddingTopBlanker c-veileder__inputomrade-med-sosken">
                        <fieldset className="c-veileder__fieldset">
                            <legend>
                                <p className="c-text-input__legend">
                                    {props.ledetekst}
                                </p>
                            </legend>
                            <div className="c-radio-input">
                                <input onClick={utdanningRadioKlikkHandler} value={ja} name="radio-utdanning" type="radio" id="radio-utdanning-ja" onChange={(): void => {}} />
                                <label htmlFor="radio-utdanning-ja">{contentResolver(epiContext, 'steg2ValgJa')}</label>
                            </div>
                            <div className="c-radio-input">
                                <input onClick={utdanningRadioKlikkHandler} value={nei} name="radio-utdanning" type="radio" id="radio-utdanning-nei" onChange={(): void => {}} />
                                <label htmlFor="radio-utdanning-nei">{contentResolver(epiContext, 'steg2ValgNei')}</label>
                            </div>
                        </fieldset>
                    </div>
                </div>
            }
            sporsmalId={props.sporsmalId}
        />
    )
}

interface MapStateToProps {
    epiContext: EpiContext<ForelopigUttalelseSkjemaSideDto>;
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: ForelopigUttalelseSkjemaSideAppState, ownProps: Steg2ComponentOwnProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
            epiContext: state.epiContext,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(Steg2ComponentVisning);